import {combineReducers} from "redux";
import myArchiveViewModel from "./myArchiveViewModel";
import inviteViewModel from "./inviteViewModel";

const rootViewModel = combineReducers({
    myArchiveViewModel,
    inviteViewModel,
});

export default rootViewModel;
